module.exports = __webpack_public_path__ + "img/car_shina2_02.c6eeea16.jpg";